import { Goto, SessionTab } from "@/shared/navigation";

/** The id of the Details tab's ingestion panel, which links scroll to. */
export const SESSION_INGESTION_ANCHOR = "session-ingestion";

/** The Details tab, scrolled to its ingestion panel. */
export function sessionIngestionPanelLink(sessionId: string) {
  return {
    pathname: Goto.createSessionRoute(sessionId, SessionTab.Details),
    hash: SESSION_INGESTION_ANCHOR,
  };
}
